function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 16,
  cy: 16,
  r: 16,
  fill: "#526DF2"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6 6h20v20H6z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  fillRule: "nonzero",
  d: "M8.5 20.55v2.533c0 .234.183.417.417.417h2.533a.393.393 0 00.292-.125l9.1-9.092-3.125-3.125-9.092 9.092a.41.41 0 00-.125.3zm14.758-8.683a.83.83 0 000-1.175l-1.95-1.95a.83.83 0 00-1.175 0l-1.525 1.525 3.125 3.125 1.525-1.525z"
}));

function SvgEditContract(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIzMiIgaGVpZ2h0PSIzMiIgdmlld0JveD0iMCAwIDMyIDMyIj4KICAgIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPGNpcmNsZSBjeD0iMTYiIGN5PSIxNiIgcj0iMTYiIGZpbGw9IiM1MjZERjIiLz4KICAgICAgICA8Zz4KICAgICAgICAgICAgPHBhdGggZD0iTTAgMEwyMCAwIDIwIDIwIDAgMjB6IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSg2IDYpIi8+CiAgICAgICAgICAgIDxwYXRoIGZpbGw9IiNGRkYiIGZpbGwtcnVsZT0ibm9uemVybyIgZD0iTTIuNSAxNC41NXYyLjUzM2MwIC4yMzQuMTgzLjQxNy40MTcuNDE3SDUuNDVjLjEwOCAwIC4yMTctLjA0Mi4yOTItLjEyNWw5LjEtOS4wOTItMy4xMjUtMy4xMjUtOS4wOTIgOS4wOTJjLS4wODMuMDgzLS4xMjUuMTgzLS4xMjUuM3ptMTQuNzU4LTguNjgzYy4zMjUtLjMyNS4zMjUtLjg1IDAtMS4xNzVsLTEuOTUtMS45NWMtLjMyNS0uMzI1LS44NS0uMzI1LTEuMTc1IDBsLTEuNTI1IDEuNTI1IDMuMTI1IDMuMTI1IDEuNTI1LTEuNTI1eiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoNiA2KSIvPgogICAgICAgIDwvZz4KICAgIDwvZz4KPC9zdmc+Cg==";
export { SvgEditContract as ReactComponent };